import React from 'react';
import '../styles/Features.css';

const Features = () => {
  const features = [
    {
      id: 1,
      icon: 'https://img.icons8.com/?size=100&id=103933&format=png&color=000000',
      description:
        'We the management & Employees are committed to provide defect free products & Services, economically: on time, first time & Every time to our customers, at a profit to us.'
    },
    {
      id: 2,
      icon: 'https://img.icons8.com/?size=100&id=GAWV3VnrpyMD&format=png&color=000000',
      title: 'Secure',
      description: ' To achieve this everyone of us will put in sustained & dedicated efforts to improve the quality of the products & services we offer.'
    },
    {
      id: 3,
      icon: 'https://img.icons8.com/?size=100&id=26293&format=png&color=000000',
      title: 'Unmatched Product Excellence',
      description:
        'Precision Turned Components, Machined parts, assemblies and Sub assemblies.' 
      },
    {
      id: 4,
      icon: 'https://img.icons8.com/?size=100&id=53764&format=png&color=000000',
      title: 'Unmatched Product Excellence',
      description:
        'At Sujay Industries, quality is our hallmark. Every product is crafted with precision and care, adhering to the highest industry standards.'
    },
    {
      id: 5,
      icon: 'https://img.icons8.com/?size=100&id=qXU73LsTm7yU&format=png&color=000000',
      title: 'Unmatched Product Excellence',
      description:
        '  An Experience of over 2 decade in the field.'
    },
    {
      id: 5,
      icon: 'https://img.icons8.com/?size=100&id=105316&format=png&color=000000',
      title: 'Unmatched Product Excellence',
      description:
        ' Patronage of our Esteemed OE Customers for over a decade'
    }
  ];

  const discoverCards = [
    {
      id: 1,
      headline: 'Key Challenges',
      description: 'Manufacture defect free products .Standardized and well documented methods',
      image: 'https://img.freepik.com/free-vector/persistence-abstract-concept_335657-3016.jpg?t=st=1731129733~exp=1731133333~hmac=5f6a9a0dbc36bd6bbc2814b0483ddd34d614d34904119d8487f12cee329ef6ee&w=740',
    },
    {
      id: 2,
      headline: 'Lowest Cost',
      description: ['Combination of CNC technology.','Conventional machines in house','Forging, plating and heat treatment partners'],
      image: 'https://img.freepik.com/free-vector/digital-money-indian-rupee-futuristic-circuit-technology-background_1017-41096.jpg?t=st=1731130297~exp=1731133897~hmac=78858b20364fd5253c029f05cfb5d1e3f75cf52c38e69c8264f89f7fa1ed01b6&w=740',
    },
    {
      id: 3,
      headline: 'Fastest Delivery ',
      description: 'Partner with us for unmatched reliability and service.',
      image: 'https://img.freepik.com/premium-vector/fast-delivery-vector-design_809852-766.jpg?w=1060',
    },
  ];

  return (
    <section className="features" id="features">
      <div className="features-container">
        {/* Left side: Image */}
        <div className="features-image">
          <img
            src={require('../assets/worker.jpg')}
            alt="Features"
          />
        </div>

        {/* Right side: Features List */}
        <div className="features-content">
          <div className="features-grid">
            <h3>
              Sujay Industries is a leader in manufacturing, known for delivering innovative, high-quality products across various sectors with a commitment to excellence.
            </h3>
            {features.map((feature) => (
              <div key={feature.id} className="feature-card">
                <img src={feature.icon} alt={feature.title} className="feature-icon"></img>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Discover Section */}
      <div className="discover-section">
        <h2>Discover how our innovative solutions can enhance your operations and drive your business forward.</h2>
        <div className="discover-grid">
          {discoverCards.map((card) => (
            <div key={card.id} className="discover-card">
              <img src={card.image} alt={card.headline} />
              <h3>{card.headline}</h3>
              <p>{card.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
